
<div>
    @if (this.data) {
    <div class="card-container">
        <mat-card class="status-card" [routerLink]="routerLink">
            <div class="card-heading">Total Debtors</div>
            <div class="content currency">
                {{nrHelper.toFormattedCurrency(+data.debtors.totalDebtors, 0)}}
            </div>
            <div class="footer">
                Total Outstanding
            </div>
        </mat-card>

        <mat-card class="status-card" [routerLink]="routerLink">
            <div class="card-heading">Current Year</div>
            <div class="content currency">
                {{nrHelper.toFormattedCurrency(+data.debtors.currentYear, 0)}}
            </div>
            <div class="footer">
                This years charges outstanding
            </div>
        </mat-card>

        <mat-card class="status-card" [routerLink]="routerLink">
            <div class="card-heading">Arrears</div>
            <div class="content currency">
                {{nrHelper.toFormattedCurrency(+data.debtors.arrears, 0)}}
            </div>
            <div class="footer">
                Arrears from previous years
            </div>
        </mat-card>

        <mat-card class="status-card" [routerLink]="routerLink">
            <div class="card-heading">Likely Receipts</div>
            <div class="content currency">
                {{nrHelper.toFormattedCurrency(+data.debtors.likelyReceipts, 0)}}
            </div>
            <div class="footer">
                Outstanding from units who paid last year
            </div>
        </mat-card>            
    </div>
    }
</div>